import { InjectionToken } from '@angular/core';
import { ChatComponent } from '../_shared/chat-types';

export const TUMBLE_DRYER = new InjectionToken<ChatComponent>('TUMBLE_DRYER');
